<template>
  <UILayoutNoData
    v-bind="mainProps"
    :hide-question-icon
    data-refid="connectorsNoData"
    @click:help="handleClickHelp"
  >
    <template #text-description>{{ caption }}</template>
    <template v-if="!isReadonly" #default>
      <UIButtonSync
        :leading="PlusIcon"
        v-bind="{ disabled }"
        label="Connect"
        :loading="syncing"
        full
        data-refid="connectorsAddButton"
        @click="handleClickAdd"
      />
    </template>
    <template #text-question>What is a connectors?</template>
  </UILayoutNoData>
</template>

<script setup lang="ts">
import { computed, inject, markRaw } from 'vue'

import { ReadonlyMode } from '@types'
import { READONLY_MODE } from '@/const'

import { useLinkedDataConnector } from '@/hooks/linkedDataConnector'

import { useHubspot } from '@/plugins/hubspot'

import { useModalsStore } from '@/store/modals'

import { UIButtonSync } from '@ui/buttons'
import { UILayoutNoData } from '@ui/core'
import { PlusIcon } from '@heroicons/vue/24/outline'
import AddAccount from '@/views/LinkedData/Connectors/components/AddAccount.vue'

const modalsStore = useModalsStore()
const hubspot = useHubspot()

const { loading, syncing } = useLinkedDataConnector()

const isReadonly = inject<ReadonlyMode>(READONLY_MODE)

const hideQuestionIcon = computed(() => !hubspot?.isLoaded)

const disabled = computed(() => syncing.value || loading.value)

const mainProps = computed(() =>
  isReadonly?.value ? { inline: true, hideQuestionIcon: true } : undefined,
)

const caption = computed(() =>
  isReadonly?.value
    ? 'No accounts connected with current repository'
    : 'Get started by connecting accounts',
)

const handleClickAdd = () => {
  const modalInstance = modalsStore.init('add-account', markRaw(AddAccount))
  modalInstance?.open(modalsStore.getZIndex())
}

const handleClickHelp = () => {
  hubspot?.open()
}
</script>
